import classNames from 'classnames/bind';
import styles from './InactiveAccount.module.css';

import Information from '../Information';
import {
  DELETE_CONDITIONS,
  DELETE_DESC,
  DELETE_DUE_DATE,
  INACTIVE_ACCOUNT_INFO,
  INACTIVE_DATE,
  INACTIVE_EXPLANATION,
  LAST_LOGIN_DATE,
} from '../../../constants';

import { useLocation } from 'react-router-dom';
import { formatDate } from '../../../utils/date';

export default function InactiveAccount() {
  const cx = classNames.bind(styles);
  const { state } = useLocation();
  const { accountInfo } = state;
  const { lastDate, changeDate, deleteDate } = accountInfo;
  const displayedInfoList = [
    { title: LAST_LOGIN_DATE, value: lastDate },
    { title: INACTIVE_DATE, value: changeDate },
    { title: DELETE_DUE_DATE, value: deleteDate },
  ];

  const TopDescription = () => (
    <span dangerouslySetInnerHTML={{ __html: INACTIVE_EXPLANATION }}></span>
  );

  const Info = () => (
    <>
      {displayedInfoList.map(({ title, value }) => (
        <p key={title}>
          {title}: <span>{formatDate(value)}</span>
        </p>
      ))}
    </>
  );

  const BottomDescription = () => (
    <>
      <span dangerouslySetInnerHTML={{ __html: DELETE_CONDITIONS }}></span>
      {DELETE_DESC}
    </>
  );

  return (
    <>
      <Information title={INACTIVE_ACCOUNT_INFO} info={accountInfo}>
        <TopDescription />
        <Info />
        <BottomDescription />
      </Information>
    </>
  );
}
